import { withRouter } from "react-router-dom";
import { SidebarComponent } from "./sidebar.component";
import { connect } from 'react-redux'
import { Layout } from "@components/layout";
import withStyles from '@material-ui/core/styles/withStyles';
import {withTheme} from "@material-ui/core/styles";
import styles from './styles';
import { withCookies } from 'react-cookie';
import withWidth from "@material-ui/core/withWidth";
import { compose } from 'redux'

const mapStateToProps = (state, props) => ({
    isOpened: state.layout.sidebar.isOpened || false,
    isHover: state.layout.sidebar.isHover || false,
    subMenu: state.layout.sidebar.subMenu,
    counters: state.layout.counters,
    context: state.context
});

const actions = {
    openSidebar: Layout.actions.openSidebar,
    closeSidebar: Layout.actions.closeSidebar,
    openPreloader: Layout.actions.openPreloader,
    toggleSubMenu: Layout.actions.toggleSubMenu,
    onMouseOverSidebar: Layout.actions.onMouseOverSidebar,
    onMouseLeaveSidebar: Layout.actions.onMouseLeaveSidebar,
    onMouseOverOpenedSidebar: Layout.actions.onMouseOverOpenedSidebar,
    onMouseLeaveOpenedSidebar: Layout.actions.onMouseLeaveOpenedSidebar,
};

export const SidebarContainer = connect(mapStateToProps, actions)(
    compose(
        withRouter,
        withWidth(),
        withTheme,
        withStyles(styles),
        withCookies,
    )(SidebarComponent)
);
